export default {
  // Tabs
  fiatCurrencySummary: "Fiat Currency Summary",
  virtualCurrencySummary: "Virtual Currency Summary",
  transactionDetails: "Transaction Details",

  // Download
  downloadFileName: "Data Details",
};
